export default "__VITE_ASSET__krutswAC__"